export default "__VITE_ASSET__e42c81e2__"